import HomeContents from "@/containers/HomeContianer/components/HomeContents";
import MainBanner from "@/containers/HomeContianer/components/MainBanner";
import { NextLink } from "goi_common";

// export const getStaticProps: GetStaticProps = async ({ params }) => {
//   const homeMetaTag = system.defaultMetaData;

//   return {
//     props: { ...homeMetaTag },
//   };
// };

// 데이터 패칭 없어서 굳이, SSG 따로 해줄 필요없음.
// html 자동으로 생성됨.

export default function Home() {
  return (
    <>
      <MainBanner />
      <HomeContents />
      {/* /content 콘텐츠 허브로의 내부 크롤 유입 링크 */}
      <nav css={{ padding: "20px" }}>
        <NextLink href="/content/">
          <span className="white caption_12_m" css={{ textDecoration: "underline" }}>
            콘텐츠 보기
          </span>
        </NextLink>
      </nav>
    </>
  );
}
